import {TYPE_PDF} from '@/contants/base';

export function getPdfPageCounts(files = []) {
  return (files || []).reduce((counts, file) => {
    const pageCount = Number(file.pages);
    if (file.config?.type === TYPE_PDF && Number.isInteger(pageCount) && pageCount > 0) {
      counts[file.id] = pageCount;
    }
    return counts;
  }, {});
}

export function isFieldOnExistingPdfPage(field, pdfPageCounts) {
  const pageCount = pdfPageCounts[field.file_id];
  if (pageCount == null) return true;

  return Number.isInteger(field.position?.page) &&
    field.position.page >= 0 && field.position.page < pageCount;
}
